import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet/es/Helmet"

import SEO from "../components/SEO"
import Heading from "../components/Heading"
import Filters from "../components/Filters"
import ProductTile from "../components/ProductTile"

import styles from "./collection.module.scss"

const Collection = ({ data, location }) => {
  const {
    productCollection
  } = data

  const [filteredStyles, setFilteredStyles] = useState(productCollection.styles)

  const [filteredColor, setFilteredColor] = useState(null)

  // Assign featured_order property to set initial sort order
  useEffect(() => {
    productCollection.styles.forEach((style, i) => {
      style.featured_order = i
    })
  }, [productCollection.styles])

  return (
    <>
      <SEO
        title={productCollection.title}
        description={productCollection.description}
        url={location.pathname}
      />

      <header className={styles.header}>
        <Heading
          tag="h1"
          level="0"
          className={styles.heading}
        >
          {productCollection.title}
        </Heading>
        <Filters
          allItems={productCollection.styles}
          items={filteredStyles}
          setItems={setFilteredStyles}
          setFilteredColor={setFilteredColor}
          isBags={productCollection.title === "Bags"}
        />
      </header>
      <ul className={styles.grid}>
        {filteredStyles.map((style, i) => (
          <ProductTile
            key={i}
            index={i}
            style={style}
            filteredColor={filteredColor}
            customStyles={styles}
            origin={`collection-${productCollection.handle}`}
          />
        ))}
      </ul>

      <Helmet>
        <script>{`
          var criteo_items = [];
          ${productCollection.styles.slice(0, 3).forEach(item => (
            `criteo_items.push("${item.product_id}");`
          ))}
          window.criteo_q = window.criteo_q || [];
          window.criteo_q.push(
          { event: "viewList", ecpplugin: "shopify", product: criteo_items}
          );
        `}</script>
      </Helmet>
    </>
  )
}

export default Collection

export const query = graphql`
  query CollectionQuery($id: String) {
    productCollection(id: { eq: $id }) {
      id
      handle
      title
      description
      descriptionHtml
      styles {
        ...PLPStyleFragment
      }
    }
  }
`

